<template>
    <div :style="{'display':'flex'}">
        今天需背;
        <div :style="{'display':'flex','margin-top': '0px'}">
            <el-row :style="{'display':'flex','margin-top': '0px'}">
                <div :style="{'flex':'1'}" v-for="(item,index) in this.$store.state.a.planWordLIst"  :key="index" @click="aaa(item.startdate)">
                    <el-col :span="24"><div class="grid-content bg-purple-light" > {{item.startdate}}号{{item.num}}个词</div></el-col>
<!--                    <el-row>-->
<!--&lt;!&ndash;                        <el-col :span="24"><div class="grid-content bg-purple-dark">{{item.startdate}}</div></el-col>&ndash;&gt;-->
<!--                    </el-row>-->
<!--                    <el-row>-->
<!--                    <el-col :span="24"><div class="grid-content bg-purple-dark">{{item.num}}dfgd</div></el-col>-->
<!--                    </el-row>-->
                </div>

<!--                <el-col :span="6"><div class="grid-content bg-purple-light">{{$store.state.a.planWordLIst[0].num}}</div></el-col>-->
<!--                <el-col :span="6"><div class="grid-content bg-purple-light">七天前背的单词{{2222222}}</div></el-col>-->
<!--                <el-col :span="6"><div class="grid-content bg-purple-light">十五天前背的单词{{2222222}}</div></el-col>-->
            </el-row>
        </div>
    </div>
</template>

<script>
    export default {
        name: "MemoryTool",
        methods:{
            aaa(aa){
                // let fdaa='sdf';
                // this.$store.dispatch('requireDateWord',fdaa),
                this.$store.dispatch('requireDateWord',aa);
                // alert(aa);
            }
        }
    }
</script>

<style scoped>
    .el-row {
        margin-bottom: 13px;
    &:last-child {
         margin-bottom: 0;
     }
    }
    .el-col {
        border-radius: 4px;
        margin-top: 0px;
    }
    /*.bg-purple-dark {*/
    /*      background: #99a9bf;*/
    /*  }*/
    /*.bg-purple {*/
    /*    background: #d3dce6;*/
    /*}*/
    /*.bg-purple-light {*/
    /*    background: #e5e9f2;*/
    /*}*/
    .grid-content {
        border-radius: 4px;
        min-height: 6px;
    }
    .row-bg {
        padding: 10px 0;
        background-color: #f9fafc;
    }
</style>